<template>
  <div class="container">
    <form class="form-horizontal" v-on:submit="save">
      <div class="columns">
        <div class="col-3 col-md-12">
          <label class="form-label">{{question.text}}</label>
        </div>
        <div class="col-4 col-md-12">
          <div class="input-group">
            <input class="form-input" type="number" v-model="answer.atxt" @blur="save"/>
            <!-- <button type="submit" class="btn btn-primary input-group-btn" @click.prevent="save">Save</button> -->
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import baseQ from '@/components/questions/base'
export default {
  name: 'numberQ',
  extends: baseQ
}
</script>



// WEBPACK FOOTER //
// number.vue?4073c557